// Zod schemas for validation, see: https://zod.dev

import z from 'zod';
import { isValidVin } from './vin';
import { usaStateValues } from './states';

export const zipSchema = z.string().min(1, 'ZIP code is required').length(5, 'ZIP code must be 5 characters.');

export const stateSchema = z.enum(usaStateValues, {
    error: iss => (iss.input === '' ? 'State is required' : 'Invalid state selection'),
});

export const licenseOrVinSchema = z.string().superRefine((value, ctx) => {
    // Reject characters not allowed by the input pattern
    if (/[^0-9a-zA-Z \\-]/.test(value)) {
        return ctx.addIssue({
            code: 'custom',
            message: 'Only letters, numbers, spaces, and hyphens are allowed.',
        });
    }

    if (!value.length) {
        return ctx.addIssue({
            code: 'custom',
            message: 'License Plate or VIN must be entered.',
        });
    }

    // Is a valid plate (alphanumeric length ≤10)
    if (value.length <= 10) return;

    // Is not a valid plate or VIN length
    if (value.length != 17) {
        return ctx.addIssue({
            code: 'custom',
            message: 'VIN must be a 17 character Vehicle Identification Number.',
        });
    }

    // Is not a valid vin format
    if (!isValidVin(value)) {
        {
            return ctx.addIssue({
                code: 'custom',
                message:
                    'VIN must be a valid Vehicle Identification Number. Please check that you have entered the VIN correctly.',
            });
        }
    }
});
